import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../Sections/CheckinEntry";
import MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry from "../../../Sections/DirectiveEntry/Entries/ExecutionEntry";
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from "../../../Sections/EstablishmentChoiceEntry";
import MaintenanceWorkflowForwardingFinancialReviewEntrySection from "../../../Sections/FinancialReviewEntry";
import MaintenanceWorkflowForwardingFiscalAssessmentEntrySection from "../../../Sections/FiscalAssessmentEntry";

const OnGoingFiscalAssessment = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingFiscalAssessmentEntrySection />

      <MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry
        showCompleted
      />

      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingFinancialReviewEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection />
    </>
  );
}

export default OnGoingFiscalAssessment;
